/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
class GmaoPieChartController {
    /** @ngInject */
    constructor($log, configuration) {
        this.$log = $log;
        this.configuration = configuration;
        this.$log.debug('Controller \'GmaoPieChartController\' loaded');
    }

    $onInit() {
        this.chartOptions = {
            chart: {
                type: 'pieChart',
                height: 500,
                legend: {
                    margin : {
                        top: 10,
                        right: 10,
                        bottom: 10,
                        left: 10
                    }
                },
                margin : {
                    top: 80,
                    right: 20,
                    bottom: 80,
                    left: 20
                },

                x: record => record ? record.label : record,
                y: record => record ? record.value : record,

                labelThreshold: 0.01,
                labelSunbeamLayout: true,
                showValues: true,
                labelsOutside: true,
                labelType: d => {
                    const percentage = (d.endAngle - d.startAngle) / (2 * Math.PI);
                    return d.data.label + ' (' + d3.format('.2%')(percentage) + ')';
                }
            }
        };
    }
}

export { GmaoPieChartController };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/statistics/component/GmaoPieChart.js